var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGeneral(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons/general"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29 18V27C29 28.1046 28.1046 29 27 29H3C1.89543 29 1 28.1046 1 27V18V15V14.16L4.29792 1.49598C4.52737 0.614913 5.32292 0 6.23337 0H23.7666C24.6771 0 25.4726 0.614913 25.7021 1.49598L29 14.16V15V18ZM26.1187 15L22.9937 3H7.00631L3.88131 15H26.1187ZM9 6C8.44772 6 8 6.44772 8 7C8 7.55228 8.44772 8 9 8H21C21.5523 8 22 7.55228 22 7C22 6.44772 21.5523 6 21 6H9ZM8 10C7.44772 10 7 10.4477 7 11C7 11.5523 7.44772 12 8 12H22C22.5523 12 23 11.5523 23 11C23 10.4477 22.5523 10 22 10H8ZM9 20.5C8.44772 20.5 8 20.9477 8 21.5C8 22.0523 8.44772 22.5 9 22.5H21C21.5523 22.5 22 22.0523 22 21.5C22 20.9477 21.5523 20.5 21 20.5H9Z",
    fill: "#A3B0C2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeneral);
export default __webpack_public_path__ + "static/media/general.f80b4b1355a54e4e0cd033e5022b8d87.svg";
export { ForwardRef as ReactComponent };